export const INBOUND_ORDER_TYPES = ['PURCHASE_ORDER', 'TRANSFER_ORDER'];
//# sourceMappingURL=inbound-order-type.js.map